var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowserAgentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 14 16",
    width: "1em",
    height: "1em",
    className: "browser_agent_icon_svg__global-class-name",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3h1v1H5V3zM3 3h1v1H3V3zM1 3h1v1H1V3zm12 10H1V5h12v8zm0-9H7V3h6v1zm1-1c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3z",
    stroke: "none"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAxNCAxNiIgc2l6ZT0iMjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgY2xhc3M9Imdsb2JhbC1jbGFzcy1uYW1lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUgM2gxdjFINVYzek0zIDNoMXYxSDNWM3pNMSAzaDF2MUgxVjN6bTEyIDEwSDFWNWgxMnY4em0wLTlIN1YzaDZ2MXptMS0xYzAtLjU1LS40NS0xLTEtMUgxYy0uNTUgMC0xIC40NS0xIDF2MTBjMCAuNTUuNDUgMSAxIDFoMTJjLjU1IDAgMS0uNDUgMS0xVjN6Ij48L3BhdGg+PC9zdmc+Cg==";
export { SvgBrowserAgentIcon as ReactComponent };